export const darkThemeColors = {
  dark: {
    mainBackground: "#141414",
    mainTextColor: "#ffffff",
    noMoreColor: "#5A5A5A",
    TextColor2: "#ADADAD",
    TextColor3: "#5B5B5B",
    TextColor4: "#D9D9D9",
    TextColor5: "#8f8f8f",
    TextColor6: "#AFAFAF",
    tabBackgroundColor: "#1B1919",
    tabBarInactive: "#696F7F",
    tabBarActive: "#eaa126",
    highlightColor: "#F17E00",
    graylightColor: "#7D7D7D",
    modalBackground: "#282828",
    borderColor1: "#202020",
    tradeModalBackgroundColor: "#202020",
    tradeInputPlaceholderTextColor: "rgba(255, 255, 255, 0.2)",
    textInputBorderColor: "#373737",
    borderColor2: "#373737",
    modalBackgroundColor: "#282828",
    backgroundColor1: "rgba(146, 146, 146, 0.3)",
    white: "#FFFFFF",
    white1: "#F6F6F6",
    white2: "#F7F7F8",
    white3: "#F9F9FA",
    white4: "#FBFBFB",
    white5: "#D8D8D8",
    white6: "rgba(255,255,255,0.8)",
    white7: "rgba(255,255,255,0.2)",
    white8: "#EDEDED",
    white9: "#F2F1F5",
    white10: "#F5F5F5",
    white11: "#F6F5FA",
    white12: "#BCBFC5",
    white13: "#EBE7F6",
    white14: "rgba(255,255,255,0.7)",
    gray1: "#696F7F",
    gray2: "rgba(142,147,159,0.4)",
    gray3: "#8E939F",
    grey4: "#D9DBDF",
    grey5: "#979797",
    grey6: "#EBE9F1",
    grey7: "#646464",
    grey8: "#8F8F8F",
    grey9: "#2E2E2E",
    grey10: "#9E9E9E",
    grey11: "#2F2F2F",
    grey12: "#44413F",
    black: "#000",
    black1: "#434B5F",
    black2: "rgba(0,0,0,0.6)",
    black3: "#1F2126",
    black4: "rgba(0,0,0,0.4)",
    black5: "#AFB3BD",
    black6: "rgba(0,0,0,0.1)",
    black7: "#3e3e3e",
    red: "#ED220D",
    red1: "#F0506C",
    red2: "#E23030",
    red3: "#D91F05",
    red4: "#FF3F3E",
    red5: "#FA5151",
    green: "#1EAE45",
    green1: "#06BC39",
    green2: "#07C160",
    lightPurple: "rgba(111,64,238,0.1)",
    purple: "#6F40EE",
    purple2: "#7600F6",
    transparent: "transparent",
    splitLineColor: "#434343",
  },
};
